import React, { useMemo, useCallback } from "react";
import { Controller } from "react-hook-form";
import { useEmployees } from "../queries/employees";
import JsonApiDataSelect from "./JsonApiDataSelect";

export const EmployeeSelect = ({ clearOption, includeMe, ...jsonApiSelectProps }: any) => {
  const { query } = useEmployees();
  const employeeOptions = useCallback((item: any) => {
    return {
      key: item.id,
      value: item.id,
      text: `${item.attributes["first-name"]} ${item.attributes["last-name"]}`.trim() || item.attributes.email,
    };
  }, []);
  const finalStaticOptions = useMemo(() => {
    return includeMe
      ? [
          {
            key: "me",
            value: "me",
            text: "Me",
          },
        ]
      : undefined;
  }, [includeMe]);

  const finalClearOption = useMemo(() => {
    return (
      clearOption || {
        key: "",
        value: "0",
        text: "None",
      }
    );
  }, [clearOption]);

  return (
    <JsonApiDataSelect
      {...Object.assign({}, { placeholder: "Employee" }, jsonApiSelectProps)}
      query={query}
      toOptions={employeeOptions}
      staticOptions={finalStaticOptions}
      clearOption={finalClearOption}
    />
  );
};

export const ControlledEmployeeSelect = ({ name, control, ...employeeSelectProps }: any) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ onChange, value }) => (
        <EmployeeSelect
          {...employeeSelectProps}
          name={name}
          onChange={(e: any, { value }: any) => onChange(value)}
          value={value}
        />
      )}
    />
  );
};

export default EmployeeSelect;
